import { AbstractBaseStore, AbstractStoreState, Method } from "@/stores/AbstractBase.store.ts";
import { GoalCollection } from "@/models/GoalCollection.model.ts";
import { GoalCollectionFilterDef } from "@/stores/filters/GoalCollectionFilterDef.ts";
import { defineStore } from "pinia";
import { useUsersStore } from "@/stores/Users.store.ts";

interface GoalCollectionStoreState extends AbstractStoreState<GoalCollection, GoalCollectionFilterDef> {



}

const BaseStore = AbstractBaseStore<GoalCollection, GoalCollectionStoreState, GoalCollectionFilterDef>();

export const useGoalCollectionsStore = defineStore('goalCollections', {

	state: (): GoalCollectionStoreState  => {

		const initialFilter = new GoalCollectionFilterDef();
		const defaultFilter = new GoalCollectionFilterDef();

		return BaseStore.state({

			initialFilter,
			defaultFilter,

		});

	},

	getters: {

		...BaseStore.getters,

		apiPath(state) {
			return '/goal-collections';
		},

		defaultMask(state): string[] {
			return [
				'*',
				'classrooms.id',
			];
		},

		defaultRecordsPerPage(): number {
			return 1000;
		},

		fromClassroomId(state): (classroomId: string) => GoalCollection[] {
			return (classroomId: string) => {
				return state.items.filter((collection) => {
					return collection.classroomIds.includes(classroomId);
				});
			};
		},

		doesFilterIncludeArchivedEntries(state) {
			return state._filter?.archived;
		}

	},

	actions: {

		...BaseStore.actions,

		mapToItem(data: any): GoalCollection {
			return GoalCollection.createFromApiData(data);
		},

		onStoreChanged() {
			useUsersStore().loadMe(true);
		}

	}

});
